import { AxiosError } from 'axios';

export const errorMessage = (e: AxiosError): string =>
  e.response?.data.message ?? e.message;
